module.exports = __webpack_public_path__ + "static/media/fill-drip.09bdfdc2.svg";